import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=71c8f73a&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c8f73a')) {
      api.createRecord('71c8f73a', component.options)
    } else {
      api.reload('71c8f73a', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=71c8f73a&", function () {
      api.rerender('71c8f73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/edit.vue"
export default component.exports